<template>
  <v-container>
    <form @submit.prevent="onSubmit" class="mt-5">
      <v-row>
        <v-col>
          <h2>ຜົນຫວຍພັດທະນາ ຫວຍລາວ</h2>
          <p style="color: #9e1c20">ງວດປະຈໍາວັນທີ: {{ formattedRoundDate }}</p>
        </v-col>
        <v-col cols="12" md="6">
          <v-row class="px-3">
            <v-text-field
              @keydown.enter.prevent="onSubmit"
              counter
              maxlength="20"
              style="width: 50%; background-color: #fff"
              @keypress="onlyNumber"
              v-model="barcode"
              label="ຄົ້ນຫາໃບບິນ"
              outlined
              clearable
              class="rounded-lg mr-3"
            ></v-text-field>

            <v-btn
              v-if="loading"
              type="submit"
              class="btn"
              style="height: 56px"
              color="#9E1C20"
              elevation="0"
              :disabled="loading"
            >
              <v-progress-circular
                indeterminate
                color="error"
                size="15"
                class="ml-2"
              ></v-progress-circular>
              ກຳລັງໂຫລດ
            </v-btn>

            <v-btn
              v-else
              type="submit"
              class="btn"
              style="height: 56px"
              color="#9E1C20"
              elevation="0"
              dark
              :disabled="loading"
            >
              <v-icon>mdi-magnify</v-icon> ກວດຫວຍ
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </form>
    <v-dialog persistent v-model="dialog" max-width="400">
      <v-card>
        <!-- <v-card-title>{{ dialogTitle }}</v-card-title> -->
        <v-card-title style="display: flex; justify-content: end">
          <v-btn color="error" text @click="closeDialog"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>

        <v-card-text>
          <div style="display: flex; justify-content: center">
            <img
              style="width: 75px"
              v-if="dialogMessage === 'ກວດສອບບິນສຳເລັດ'"
              src="../../assets/check-win.png"
            />
            <img style="width: 75px" v-else src="../../assets/check-fail.png" />
          </div>

          <div
            style="display: flex; justify-content: center; margin-bottom: 40px"
          >
            <h2>{{ dialogMessage }}</h2>
          </div>

          <div v-if="dialogDetail">
            <div class="win">
              <div style="display: flex; justify-content: center; color: #fff">
                <h2>ເງິນລາງວັນ</h2>
              </div>
              <div
                style="display: flex; justify-content: center; margin-top: 10px"
              >
                <h1 style="color: #ffc308">{{ formatteWin }} ກີບ</h1>
              </div>
            </div>

            <div class="win2" v-if="Number(dialogDetail.winAmount) >= 50000000">
              <div>
                <li style="color: red">
                  <strong>ຫັກພາສີ(5%):</strong> &nbsp;-{{ formatteTax }} ກີບ
                </li>
                <li>
                  <h3>ເງິນລາງວັນທີ່ໄດ້ຮັບ: {{ formatteWinafTax }} ກີບ</h3>
                </li>
              </div>
            </div>

            <div class="winDetail">
              <li><strong>ເລກບິນ:</strong> {{ dialogDetail.BillNumber }}</li>
              <li><strong>ງວດວັນທີ:</strong> {{ dialogDetail.roundDate }}</li>
              <li><strong>ວັນໝົດອາຍຸ:</strong> {{ formatDate }}</li>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      barcode: "",
    };
  },

  computed: {
    ...mapGetters("checkLottery6", [" items", "loading"]),
    ...mapGetters("main_result6", ["result6", "textt"]),
    ...mapState("checkLottery6", [
      "dialog",
      "dialogTitle",
      "dialogMessage",
      "dialogDetail",
    ]),
    formattedRoundDate() {
      return this.result6?.length > 0
        ? moment(this.result6[1].roundDate).format("DD/MM/YYYY")
        : "";
    },
    formatDate() {
      return moment(this.dialogDetail.BillExpire).format("DD/MM/YYYY");
    },
    formatteWin() {
      return this.dialogDetail.winAmount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatteWinafTax() {
      return this.dialogDetail.winAmountAfterTax
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatteTax() {
      return this.dialogDetail.taxAmount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },

  methods: {
    ...mapActions("checkLottery6", ["postRequest"]),
    ...mapActions("main_result6", ["MainResult"]),
    ...mapMutations("checkLottery6", ["SET_DIALOG"]),
    onlyNumber(e) {
      if (!/^[0-9]*$/.test(e.key)) {
        return e.preventDefault();
      }
    },
    async onSubmit() {
      await this.postRequest({ barcode: this.barcode });
    },
    closeDialog() {
      this.SET_DIALOG({
        dialog: false,
        dialogTitle: "",
        dialogMessage: "",
        dialogDetail: null,
      });
    },
  },
  async mounted() {
    await this.MainResult();
  },
};
</script>

<style scoped>
.win {
  padding: 15px;
  background-color: #9e1c20;
  border-radius: 10px;
  margin-bottom: 10px;
}
.win2 {
  padding: 15px;
  background-color: #ffc308;
  border-radius: 10px;
  margin-bottom: 10px;
}
.winDetail {
  border-radius: 10px;
  padding: 15px;
  background-color: rgb(221, 239, 255);
}
li {
  list-style-type: none;
}
.btn {
  color: white;
}
</style>
